import PrivacyPage from 'info/privacy';

export default PrivacyPage;
